import React from "react";

export const CheckCircleBroken = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M16.5 8.31429V9.00429C16.4991 10.6216 15.9753 12.1953 15.007 13.4907C14.0386 14.786 12.6774 15.7337 11.1265 16.1922C9.57554 16.6508 7.91791 16.5957 6.40082 16.0352C4.88373 15.4747 3.58846 14.4389 2.70819 13.0821C1.82792 11.7253 1.40981 10.1203 1.51623 8.50653C1.62264 6.89272 2.24787 5.35654 3.29868 4.1271C4.34948 2.89766 5.76956 2.04083 7.34711 1.6844C8.92466 1.32798 10.5752 1.49105 12.0525 2.14929M16.5 3L8.99997 10.5075L6.74997 8.2575"
      stroke="#535862"
      strokeWidth="1.54167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
